// 保存の成否はブラウザが扱うため、この関数が終わっても保存できたとは限らない
export function downloadFile(url: string, fileName: string): void {
  const anchor = document.createElement('a');
  if (url.startsWith('blob:')) {
    // 画面が作った手元の一時アドレスなので、解放は画面に任せる
    anchor.href = url;
    anchor.download = fileName;
  } else {
    // サーバーが保存用の名前を付けて Cloud Storage へ案内するので、ブラウザ側では名前を指定しない
    anchor.href = buildDownloadUrl(url, fileName);
  }
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

// 元の問い合わせ項目と断片部分は残す
export function buildDownloadUrl(url: string, fileName: string): string {
  const [withoutFragment, fragment] = splitBefore(url, '#');
  const [path, query] = splitBefore(withoutFragment, '?');
  const params = new URLSearchParams(query.slice(1));
  params.delete('download');
  const otherQuery = params.toString();
  const downloadParam = `download=${encodeURIComponent(fileName)}`;
  if (otherQuery !== '') {
    return `${path}?${otherQuery}&${downloadParam}${fragment}`;
  }
  return `${path}?${downloadParam}${fragment}`;
}

// 後ろ側は区切り文字を含む。区切り文字が無ければ後ろ側は空
function splitBefore(value: string, separator: string): [string, string] {
  const index = value.indexOf(separator);
  if (index >= 0) {
    return [value.slice(0, index), value.slice(index)];
  }
  return [value, ''];
}
